module.exports = __webpack_public_path__ + "media/reskin-images/img--pick-path-2-6fb9d7c3.png";